import { AfterViewInit, DestroyRef, Directive, ElementRef, EventEmitter, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent, withLatestFrom, zipWith } from 'rxjs';

@Directive({
  selector: '[vtiSwipe]',
  standalone: true,
})
export class SwipeDirective implements AfterViewInit {
  @Output() public swipeLeft = new EventEmitter<void>();
  @Output() public swipeRight = new EventEmitter<void>();

  public ngAfterViewInit(): void {
    fromEvent<TouchEvent>(this.elementRef.nativeElement, 'touchstart')
      .pipe(
        zipWith(
          fromEvent<TouchEvent>(this.elementRef.nativeElement, 'touchend').pipe(
            withLatestFrom(fromEvent<TouchEvent>(this.elementRef.nativeElement, 'touchmove')),
          ),
        ),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(([touchstart, [_, touchmove]]) => {
        const xDiff = touchstart.touches[0].clientX - touchmove.touches[0].clientX;

        if (Math.abs(xDiff) > 100 && touchstart.timeStamp <= touchmove.timeStamp) {
          if (xDiff > 0) {
            this.swipeLeft.emit();
          } else {
            this.swipeRight.emit();
          }
        }
      });
  }

  private readonly destroyRef = inject(DestroyRef);
  private readonly elementRef = inject(ElementRef);
}
